// Resolves a property of the UserUnitPriceAttribute currently selected for `attributeKey`, from a
// registry of loaded attributes keyed by id. Powers the settings.yml `vap()` helper ("value of
// attribute property"), e.g. vap('printing_machine', 'printing_type') -> the selected machine's
// printing_type. Returns undefined when nothing is selected or the attribute/property is unknown
// (e.g. the attributes have not loaded yet), so expressions that use it degrade gracefully.
//
// valueBag: the form values (the selected attribute's id lives under 'user_unit_price_attribute.<key>').
// attributesById: { [id]: attribute }, where attribute.properties holds the machine's properties.
const attributeProperty = (valueBag, attributesById, attributeKey, propertyName) => {
  if (!valueBag || !attributesById) { return undefined; }

  const attributeId = valueBag['user_unit_price_attribute.' + attributeKey];
  if (attributeId == undefined) { return undefined; }

  const attribute = attributesById[attributeId];
  return (attribute && attribute.properties) ? attribute.properties[propertyName] : undefined;
};

export { attributeProperty };
